export const BASEURL = process.env.REACT_APP_SERVICE_URL;
export const IMAGEPATH = process.env.IMAGE_BASE_URL;
export type PostDataType = {
    data: {
        type: string;
        attributes: any;
    };
};
